import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { myHubKeys } from './query-keys';
import { ArticleType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { AxiosResponse } from 'axios';
import { MyHubAPI } from '../apis';

function useUnassignedSuggestionsQuery({
  companyId,
  shouldFetch = true,
}: {
  companyId: string;
  shouldFetch?: boolean;
}) {
  const { data: suggestionsData, ...rest } = useQuery<AxiosResponse<ArticleType[]>>({
    queryKey: myHubKeys.getUnassignedSuggestions({ companyId }),
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
    enabled: shouldFetch && !!companyId,
    queryFn: () => MyHubAPI.getUnassignedSuggestions({ companyId }),
  });
  const suggestions = useMemo(
    () =>
      suggestionsData?.data && Array.isArray(suggestionsData.data)
        ? suggestionsData.data || []
        : [],
    [suggestionsData],
  );

  return {
    suggestions,
    ...rest,
  };
}

export default useUnassignedSuggestionsQuery;
